import { Link } from 'react-router-dom'
import { FaChevronRight } from 'react-icons/fa6'

function HomeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 10.5L12 4L20 10.5V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V10.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M9 20V14H15V20" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  )
}

function PageBreadcrumb({ title, className = '' }) {
  if (!title) return null

  return (
    <nav className={`page-breadcrumb ${className}`.trim()} aria-label="Breadcrumb">
      <ol className="page-breadcrumb__list">
        <li className="page-breadcrumb__item">
          <Link className="page-breadcrumb__link" to="/">
            <HomeIcon />
            <span>Home</span>
          </Link>
        </li>
        <li className="page-breadcrumb__separator" aria-hidden="true">
          <FaChevronRight />
        </li>
        <li className="page-breadcrumb__item page-breadcrumb__item--current" aria-current="page">
          {title}
        </li>
      </ol>
    </nav>
  )
}

export default PageBreadcrumb
